import React from 'react';
import { motion } from 'framer-motion';
import { useMotionPreference } from '../../hooks/useMotionPreference';

/** Anna's spoken line, revealed word by word in sync with her speech. */
export function WallCaption({
  text,
  revealed,
  compact = false
}: {
  text: string;
  revealed: number;
  compact?: boolean;
}) {
  const reduce = useMotionPreference();
  const words = text.split(' ');
  return <p className={`text-balance text-center font-display font-light text-ink ${compact ? 'text-[26px] leading-[1.25] text-ink-soft' : 'text-[32px] leading-[1.2] lg:text-[38px]'}`} data-id="element-1579" data-mp="2exs0ikhdlwfv">
      <span className="sr-only" data-id="element-1580" data-mp="2omte640g81qo">{text}</span>
      <span aria-hidden data-id="element-1581" data-mp="2onv053j068n6">
        {words.map((word, i) => {
        const shown = i < revealed;
        return <motion.span key={`${word}-${i}`} className="mr-[0.26em] inline-block" initial={false} animate={{
          opacity: shown ? 1 : 0,
          y: shown || reduce ? 0 : 6,
          filter: shown || reduce ? 'blur(0px)' : 'blur(4px)'
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-1582" data-mp="2xnrm2xe0ctej" data-mpi={i}>
              {word}
            </motion.span>;
      })}
      </span>
    </p>;
}